export enum HTTP_ERROR_TYPES {
    'CHALLENGE_INVALID' = 'https://api.envestboard.com/errors/challenge-invalid'
}
